module.exports = __webpack_public_path__ + "img/mobile_landing_page_banner.e14b67ac.png";